import $ from 'jquery';

class MondayVC_CommunityCareers {

  constructor() {
    setTimeout(this.LoadActiveResults(), 750);
    this.resultsDiv = $(".allCareers__monday-vc");
    this.showButton = $(".allCareers__link");
    this.filterSelect = $(".allCareers__filter-child li");
    //this.searchField = $("#event-search");
    this.loadMoreButton = $(".allCareers__load a");
    this.postsPerPage = 12;
    this.screenWidth = $(window).width();
    this.events();
    this.isSpinnerVisible = false;
    this.isOverlayOpen = false;
    this.previousValue;
    this.typingTimer;
    this.loadInfo;
    this.body = $('body');
  }

  events() {
  }

  LoadActiveResults() {

    let page = 1;
    let per_page = 3;

    if ($(".allCareers__monday-vc").length) {

      $.getJSON(MaRS_DATA.site_url + '/wp-content/themes/marsdd-chapter/includes/mondayVc/get_request.php?page='+page+'&per_page='+per_page+'&title=', (data) => {

          $(".allCareers__monday-vc").append(`
            ${data.items.length ? '<div class="row no-gutters allCareers__row">' : '<p>No Career information matches the search term.</p>'}
              ${data.items.map(item => `

                <a class="col-12 col-md-12 allCareers__career" target="_blank" href="${item.url}">
                  <div class="row no-gutters">
                    <div class="col-12 col-md-7 allCareers__jobTitle">
                      <h3 class="allCareers__title">${item.title}</h3>
                      <span class="allCareers__company">${item.company.name}</span>
                      <span class="allCareers__venture"><span data-tooltip="A company supported by MaRS Venture Services.">Venture</span></span>
                    </div>

                    <div class="col-12 col-md-3 allCareers__details">
                      <span class="allCareers__location">${item.locations}</span>
                      <!--<span class="allCareers__type"><?= $type[0]->name ?></span>-->
                    </div>
                    <div class="col-12 col-md-2 allCareers__link">
                      <span class="button button--tertiary">Learn more</span>
                      <i class="allCareers__external"></i>
                    </div>
                  </div>
                </a>

            `).join('')}
            ${data.items.length ? '</div>' : ''}
          `);
          this.isSpinnerVisible = false;

        }).fail(function (jqXHR, textStatus, error) {
        });
    }
  }
}

export default MondayVC_CommunityCareers;